
import IndexComponent from "../../../components/lottery_coupons/Index.vue";

export default {
  components: {
    IndexComponent,
  },
};
